import { useState } from 'react';
import {
  PopoverRoot,
  PopoverTrigger,
  PopoverContent,
  PopoverClose,
} from '@acb_devel/design-system';
import { FilterButton } from '@components/assessors/atoms/FilterButton/FilterButton';
import { Badge } from '@acb_devel/design-system';
import { Checkbox } from '@acb_devel/design-system';
import { Button } from '@acb_devel/design-system';

import { STATUS_MAP } from '@data/registrationStatusMap';

import styles from './RegistrationStatusFilter.module.scss';

export function RegistrationStatusFilter({
  status,
  setStatus,
}: {
  status: string[];
  setStatus: (status: string[]) => void;
}) {
  const [selectedStatus, setSelectedStatus] = useState<string[]>(status);

  function handleCheckboxesChange(checked: boolean, status: string) {
    setSelectedStatus((prev) =>
      checked ? [...prev, status] : prev.filter((s) => s !== status)
    );
  }

  function handleApply() {
    setStatus(selectedStatus);
  }

  return (
    <PopoverRoot>
      <PopoverTrigger>
        <FilterButton>
          <strong>Estado</strong>
          {status.length > 0 &&
            ` (${status.length}): ${status
              .map(
                (status) => STATUS_MAP.find((s) => s.status === status)?.label
              )
              .join(', ')}`}
        </FilterButton>
      </PopoverTrigger>
      <PopoverContent align="start" sideOffset={10} paddingOff>
        <div className={styles.registrationStatusFilter__popoverContent}>
          <div className={styles.registrationStatusFilter__labels}>
            {STATUS_MAP.map(({ status, label, badge }) => (
              <Checkbox
                key={status}
                id={`status_${status}`}
                label={<Badge variant={badge}>{label}</Badge>}
                checked={selectedStatus.includes(status)}
                onCheckedChange={(checked) =>
                  handleCheckboxesChange(checked, status)
                }
              />
            ))}
          </div>
          <div className={styles.registrationStatusFilter__actions}>
            <PopoverClose>
              <Button
                variant="flat"
                color="primary"
                size="md"
                onClick={() => {
                  setSelectedStatus([]);
                  setStatus([]);
                }}
                upperCase={false}
              >
                Borrar
              </Button>
            </PopoverClose>
            <PopoverClose>
              <Button
                variant="solid"
                color="primary"
                size="md"
                onClick={handleApply}
                upperCase={false}
              >
                Aplicar
              </Button>
            </PopoverClose>
          </div>
        </div>
      </PopoverContent>
    </PopoverRoot>
  );
}
